import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Urls } from "../shared/urls";

@Injectable({
  providedIn: "root"
})
export class ApiService {
  constructor(private http: HttpClient) {}

  get(path: string, params: HttpParams = new HttpParams(), headers?: HttpHeaders): Promise<any> {
    return new Promise((resolve, reject) => {
      const options: any = { params };
      if (headers) {
        options.headers = headers;
      }
      this.http.get(Urls.baseUrl + path, options).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  put(path: string, body: Object = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(Urls.baseUrl + path, body).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  post(path: string, body: Object = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(Urls.baseUrl + path, body).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  delete(path: string): Promise<any> {
    return this.deleteWithBody(path);
  }

  deleteWithBody(path: string, body: Object = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.request("DELETE", Urls.baseUrl + path, { body }).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  patch(path: string, body: Object = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.patch(Urls.baseUrl + path, body).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
}
